import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import _ from "lodash";
import { Form, Segment, Button } from "semantic-ui-react";
import FormErrorMessage from "../../utils/FormErrorMessage";
import { updateOrCreateWarehouse, updateWarehouseModelInStore } from "../../../actions/setting";
import Dls from "../../../lib";

class WarehouseForm extends Component {
    constructor() {
        super();
        this.state = {
            errors: [],
            loading: false
        };
    }

    onFormSubmit = () => {
        const errors = this.validateInput();
        const action = this.props.model.id ? "Update" : "Create";
        if (_.isEmpty(errors)) {
            this.setState({
                loading: true
            });
            this.props
                .updateOrCreateWarehouse(this.props.jwt, this.props.model)
                .then(res => {
                    this.setState({
                        loading: false,
                        errors: []
                    }, () => {
                        if (action === 'Create') {
                            this.props.history.replace(`/settings/warehouses/${res.data.data.id}/show`)
                        }
                    })
                })
                .catch(err => {
                    const errors = Dls.apiErrorMessage(err);
                    this.setState({
                        loading: false,
                        errors: errors
                    });
                });
        } else {
            this.setState({
                errors: errors
            });
        }
    };

    validateInput = () => {
        const { label } = this.props.model;
        const errors = [];
        if (!label) {
            errors.push("Label field is required");
        }
        return errors;
    };
    
    render() {
        const {model, updateWarehouseModelInStore, isDirty} = this.props
        return (
            <Form size="large">
                <Segment stacked>
                    {!_.isEmpty(this.state.errors) ? (
                        <FormErrorMessage errors={this.state.errors} />
                    ) : null}
                    <Form.Group unstackable widths={2}>
                        <Form.Input 
                            fluid 
                            label="Warehouse Label"
                            name="label"
                            value={model.label ? model.label : ""} 
                            onChange={(e) => { updateWarehouseModelInStore(e.target.name, e.target.value) }}
                        />
                        <Form.Input 
                            fluid 
                            label="Company Name"
                            name="name"
                            value={model.name ? model.name : ""} 
                            onChange={(e) => { updateWarehouseModelInStore(e.target.name, e.target.value) }}
                        />
                    </Form.Group>
                    <Form.Group unstackable widths={2}>
                        <Form.Input 
                            fluid 
                            label="Contact Name"
                            name="contact"
                            value={model.contact ? model.contact : ""} 
                            onChange={(e) => { updateWarehouseModelInStore(e.target.name, e.target.value) }}
                        />
                        <Form.Input 
                            fluid 
                            label="Contact Email"
                            name="email"
                            value={model.email ? model.email : ""} 
                            onChange={(e) => { updateWarehouseModelInStore(e.target.name, e.target.value) }}
                        />
                    </Form.Group>
                    <Form.Group unstackable widths={2}>
                        <Form.Input 
                            fluid 
                            label="Contact Phone"
                            name="phone"
                            value={model.phone ? model.phone : ""} 
                            onChange={(e) => { updateWarehouseModelInStore(e.target.name, e.target.value) }}
                        />
                        <Form.Select fluid label='Status' options={[
                                {key: 'Active', text: 'Active', value: 'Active'},
                                {key: 'Disabled', text: 'Disabled', value: 'Disabled'}
                            ]} name="status" value={model.status ? model.status : "Active"} 
                            onChange={(e,data) => { updateWarehouseModelInStore('status', data.value) }}
                        />
                    </Form.Group>
                    <Form.Group unstackable widths={2}>
                        <Form.Input 
                            fluid 
                            label="Address 1"
                            name="street1"
                            value={model.street1 ? model.street1 : ""} 
                            onChange={(e) => { updateWarehouseModelInStore(e.target.name, e.target.value) }}
                        />
                        <Form.Input 
                            fluid 
                            label="Address 2"
                            name="street2"
                            value={model.street2 ? model.street2 : ""} 
                            onChange={(e) => { updateWarehouseModelInStore(e.target.name, e.target.value) }}
                        />
                    </Form.Group>
                    <Form.Group unstackable widths={2}>
                        <Form.Input 
                            fluid 
                            label="City"
                            name="city"
                            value={model.city ? model.city : ""} 
                            onChange={(e) => { updateWarehouseModelInStore(e.target.name, e.target.value) }}
                        />
                        <Form.Input 
                            fluid 
                            label="Postal"
                            name="postal"
                            value={model.postal ? model.postal : ""} 
                            onChange={(e) => { updateWarehouseModelInStore(e.target.name, e.target.value) }}
                        />
                    </Form.Group>
                    <Form.Group unstackable widths={2}>
                        <Form.Input 
                            fluid 
                            label="State Code"
                            name="state"
                            value={model.state ? model.state : ""} 
                            onChange={(e) => { updateWarehouseModelInStore(e.target.name, e.target.value) }}
                        />
                        <Form.Input 
                            fluid 
                            label="Country Code"
                            name="country"
                            value={model.country ? model.country : ""} 
                            onChange={(e) => { updateWarehouseModelInStore(e.target.name, e.target.value) }}
                        />
                    </Form.Group>
                    <Form.Group unstackable widths={1}>
                        <Form.Checkbox
                            label="This warehouse holds stock"
                            name="stock"
                            onChange={(e,data) => { updateWarehouseModelInStore('stock', data.checked) }}
                            checked={model.stock}
                        />
                    </Form.Group>
                    <Button
                        color="teal"
                        onClick={this.onFormSubmit}
                        size="large"
                        loading={this.state.loading}
                        disabled={!isDirty}
                    >
                        Save
                    </Button>
                </Segment>
            </Form>
        );
    }
}

WarehouseForm.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func.isRequired
    }).isRequired,
    updateOrCreateWarehouse: PropTypes.func.isRequired,
    updateWarehouseModelInStore: PropTypes.func.isRequired,
    model: PropTypes.object.isRequired,
    isDirty: PropTypes.bool.isRequired,
    jwt: PropTypes.string.isRequired
};

function mapStateToProps(state) {
    return {
        model: state.warehouse.model,
        isDirty: state.warehouse.dirty,
        jwt: state.auth.jwt
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            updateOrCreateWarehouse,
            updateWarehouseModelInStore
        },
        dispatch
    );
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(WarehouseForm);



// WEBPACK FOOTER //
// ./src/components/forms/settings/Warehouse.js